module.exports = __webpack_public_path__ + "img/姫路康太郎.f0f426d3.jpg";